module.exports = __webpack_public_path__ + "img/company-logo-white.dbe6b7ff.svg";